// extracted by mini-css-extract-plugin
export default {"problemsSolvedDivider":"ProblemsSolvedDivider_problemsSolvedDivider__NdlAC"};